import _ from 'ckLodash';
import bi from 'utils/biUtils';

var VARIABLE_NAME = 'STYLE_VAR';

//todo - review and refactor - should move to elementUtils
function findMatchingElements(elementPath, style) {
    var matched = [];
    switch (style.type) {
        case CKEDITOR.STYLE_BLOCK:
            if (elementPath.block && style.checkElementRemovable(elementPath.block, true)) {
                matched.push(elementPath.block);
            }
            if (elementPath.blockLimit && style.checkElementRemovable(elementPath.blockLimit, true)) {
                matched.push(elementPath.blockLimit);
            }
            break;
        case CKEDITOR.STYLE_OBJECT:
        case CKEDITOR.STYLE_INLINE:

            var elements = elementPath.elements;

            for (var i = 0, element; i < elements.length; i++) {
                element = elements[i];

                if (style.type === CKEDITOR.STYLE_INLINE && (element === elementPath.block || element === elementPath.blockLimit)) {
                    continue;
                }
                if (style.type === CKEDITOR.STYLE_OBJECT) {
                    var name = element.getName();
                    if (!(typeof style.element === 'string' ? name === style.element : name in style.element)) {
                        continue;
                    }
                }

                if (style.checkElementRemovable(element, true)) {
                    matched.push(element);
                }
            }
            break;
    }
    return matched;
}

//copied from CK
// Clones the subtree between subtreeStart (exclusive) and the
// leaf (inclusive) and inserts it into the range.
//
// @param range
// @param {CKEDITOR.dom.element[]} elements Elements path in the standard order: leaf -> root.
// @param {CKEDITOR.dom.element/null} substreeStart The start of the subtree.
// If null, then the leaf belongs to the subtree.
//todo - review and refactore
function cloneSubtreeIntoRange(range, elements, subtreeStart) {
    var current = elements.pop();
    if (!current) {
        return;
    }
    // Rewind the elements array up to the subtreeStart and then start the real cloning.
    if (subtreeStart) {
        cloneSubtreeIntoRange(range, elements, current.equals(subtreeStart) ? null : subtreeStart);
    } else {
        var clone = current.clone();
        range.insertNode(clone);
        range.moveToPosition(clone, CKEDITOR.POSITION_AFTER_START);

        cloneSubtreeIntoRange(range, elements);
    }
}

//todo - review and refactore
function fixCurrentStyle(editor, currentValue, value, defaultStyle) {
    //@Noam Inspired\Copied from font\plugin - 19/05/2015

    // When applying one style over another, first remove the previous one (#12403).
    // NOTE: This is only a temporary fix. It will be moved to the styles system (#12687).
    if (currentValue && value !== currentValue) {
        var commandStyle = defaultStyle,
            range = editor.getSelection().getRanges()[0];

        // If the range is collapsed we can't simply use the editor.removeStyle method
        // because it will remove the entire element and we want to split it instead.
        if (range.collapsed) {
            var path = editor.elementPath(),
                // Find the style element.
                matching = path.contains(function (el) {
                    return commandStyle.checkElementRemovable(el);
                });

            if (matching) {
                var startBoundary = range.checkBoundaryOfElement(matching, CKEDITOR.START),
                    endBoundary = range.checkBoundaryOfElement(matching, CKEDITOR.END),
                    node, bm;

                // If we are at both boundaries it means that the element is empty.
                // Remove it but in a way that we won't lose other empty inline elements inside it.
                // Example: <p>x<span style="font-size:48px"><em>[]</em></span>x</p>
                // Result: <p>x<em>[]</em>x</p>
                if (startBoundary && endBoundary) {
                    bm = range.createBookmark();
                    // Replace the element with its children (TODO element.replaceWithChildren).
                    while ((node = matching.getFirst())) {
                        node.insertBefore(matching);
                    }
                    matching.remove();
                    range.moveToBookmark(bm);

                    // If we are at the boundary of the style element, just move out.
                } else if (startBoundary) {
                    range.moveToPosition(matching, CKEDITOR.POSITION_BEFORE_START);
                } else if (endBoundary) {
                    range.moveToPosition(matching, CKEDITOR.POSITION_AFTER_END);
                } else {
                    // Split the element and clone the elements that were in the path
                    // (between the startContainer and the matching element)
                    // into the new place.
                    range.splitElement(matching);
                    range.moveToPosition(matching, CKEDITOR.POSITION_AFTER_END);
                    cloneSubtreeIntoRange(range, path.elements.slice(), matching);
                }

                editor.getSelection().selectRanges([range]);
            }
        } else {
            editor.removeStyle(commandStyle);
        }
    }
}

//finish copy from CK

function StyleCommand(elemType, styleName, extraDefinition) {
    this.styleDefinition = {
        element: elemType,
        styles: {}
    };

    this.styleDefinition.styles[styleName] = '#(' + VARIABLE_NAME + ')';
    this.styleName = styleName;
    _.assign(this.styleDefinition, extraDefinition);
}

function createCKStyle(paramValue, styleDefinition) {
    var variablesValues = {};
    variablesValues[VARIABLE_NAME] = paramValue;
    return new CKEDITOR.style(styleDefinition, variablesValues);
}

function createGeneralStyle(styleDefinition) {
    return createCKStyle('inherit', styleDefinition);
}

function getStyleValue(element, styleName) {
    var styleValue = element.getStyle(styleName);
    if (!styleValue && styleValue !== 0) {
        styleValue = undefined;
    }
    return styleValue;
}

function getFirstStyleName(styleDefinition) {
    return _.keys(styleDefinition.styles)[0];
}

StyleCommand.prototype = {
    contextSensitive: true, //Config CK to call refresh the command after selection change
    exec: function (editor, paramsValue) {
        //Either remove current style to prevent nested style or change the selection range so that the
        //current style will be fixed\removed when applying the new style later
        fixCurrentStyle(editor, this.state, paramsValue, createGeneralStyle(this.styleDefinition));

        if (paramsValue !== CKEDITOR.TRISTATE_OFF) {
            editor.applyStyle(createCKStyle(paramsValue, this.styleDefinition));
        } else {
            editor.removeStyle(createGeneralStyle(this.styleDefinition));
        }

        return true;
    },
    refresh: function (editor, elementPath) {
        var state,
            stylesElements = findMatchingElements(elementPath, createGeneralStyle(this.styleDefinition));

        if (stylesElements.length === 0) {
            state = CKEDITOR.TRISTATE_OFF;
        } else {
            if (stylesElements.length > 1) {
                bi.error.nestedStyles(this.styleName);
            }

            state = getStyleValue(stylesElements[0], getFirstStyleName(this.styleDefinition));
        }
        this.setState(state);
    }
};

export default StyleCommand;
